import styled from 'styled-components'

export const QuestionWrapper = styled.div`
    -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 2s; /* Firefox < 16 */
        -ms-animation: fadein 2s; /* Internet Explorer */
         -o-animation: fadein 2s; /* Opera < 12.1 */
            animation: fadein 2s;
`

export const QuestionText = styled.div`
    text-align: center;
    font-size: ${props => (props.fontSize ? `${props.fontSize}` : '2rem')};
    margin: 20px 10px ${props => (props.marginBottom ? `${props.marginBottom}` : '80')}px 10px;
    min-height: ${props => (props.minHeight ? `${props.minHeight}` : '230')}px;
    position: relative;
`

export const QuestionTextSpan = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
`

export const OptionsWrapper = styled.div`
    text-align: center;
    font-size: 2rem;
    margin: ${props => (props.marginTop ? `${props.marginTop}` : '20')}px 10px;
`

export const QuestionBackLink = styled.div`
    margin-top: 10px;
    margin-left: 10px;
`

export const QuestionBackLinkEmpty = styled.div`
    margin-top: 5px;
    height: 24px;
`

export const QuestionPlusWrapper = styled.div`
    text-align: ${props => (props.align ? `${props.align}` : 'center')};
    height: 72px;
    
    span {
        line-height: 72px;
    }
`

export const QuestionMinusWrapper = styled.div`
    text-align: ${props => (props.align ? `${props.align}` : 'center')};
    height: 72px;
    
    span {
        line-height: 72px;
    }
`

export const QuestionMinutes = styled.div`
    text-align: ${props => (props.align ? `${props.align}` : 'center')};
    font-size: 3rem;
    line-height: ${props => (props.lineHeight ? `${props.lineHeight}px` : 'initial')};
`

export const QuestionMinutesLabel = styled.div`
    text-align: center;
    font-size: 2rem;
    margin-bottom: 100px;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/IntroQuestions/Question.js